import axios from 'axios';
import { PATH_MODULE_RULES } from '../constants/clientModules';
import AuthService from '../../modules/Admin/services/AuthService';

const API_URL = process.env.REACT_APP_API_URL;

export const MODULE_ACCESS_STORAGE_KEY = 'nf_client_module_access_v1';

let inflight = null;

function storedRoleId() {
  const r = AuthService.getLoggedInRoleId();
  return r != null ? Number(r) : NaN;
}

function storedClientId() {
  const c = AuthService.getLoggedInClientId();
  return c != null && c !== '' ? String(c) : '';
}

function storedAccessToken() {
  return AuthService.getToken();
}

export function clearModuleAccessCache() {
  try {
    sessionStorage.removeItem(MODULE_ACCESS_STORAGE_KEY);
  } catch {
    /* ignore */
  }
  inflight = null;
}

/** Fetch module map for logged-in tenant and cache in sessionStorage. */
export async function prefetchTenantModuleAccess() {
  const role = storedRoleId();
  if (role === 1 || Number.isNaN(role)) {
    clearModuleAccessCache();
    return;
  }
  const cid = storedClientId();
  if (!cid) return;

  const token = storedAccessToken();
  const res = await axios.get(`${API_URL}/Client/GetModuleAccess/${cid}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  sessionStorage.setItem(MODULE_ACCESS_STORAGE_KEY, JSON.stringify(res.data ?? {}));
}

export function ensureModuleAccessLoaded() {
  const role = storedRoleId();
  if (role === 1 || !storedClientId()) return Promise.resolve();
  if (sessionStorage.getItem(MODULE_ACCESS_STORAGE_KEY)) return Promise.resolve();
  if (!inflight) {
    inflight = prefetchTenantModuleAccess()
      .catch(() => {})
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export function readModuleAccessMap() {
  try {
    const raw = sessionStorage.getItem(MODULE_ACCESS_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    return typeof o === 'object' && o !== null ? o : null;
  } catch {
    return null;
  }
}

export function isModuleEnabled(moduleKey) {
  const role = storedRoleId();
  if (role === 1) return true;
  const map = readModuleAccessMap();
  if (!map || typeof map[moduleKey] === 'undefined') return false;
  return map[moduleKey] !== false;
}

export function moduleKeyForPath(pathname) {
  const path = pathname || '';
  for (const [re, key] of PATH_MODULE_RULES) {
    if (re.test(path)) return key;
  }
  return null;
}

export function isPathModuleAllowed(pathname) {
  const role = storedRoleId();
  if (role === 1) return true;
  const key = moduleKeyForPath(pathname);
  if (!key) return true;
  return isModuleEnabled(key);
}
